var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative flex-shrink-0",
      class: { "cursor-not-allowed opacity-75": _vm.disabled }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "relative h-10 w-full pl-4 pr-12 flex items-center gap-2 border rounded cursor-pointer overflow-hidden",
          class: [
            _vm.focus ? "border-light-purple" : "border-grey-200",
            _vm.disabled ? "pointer-events-none bg-grey-100" : "bg-pure-white"
          ],
          on: {
            click: function($event) {
              _vm.focus = true
            }
          }
        },
        [
          _vm.input.length === 0
            ? _c(
                "div",
                [
                  _c("BlTextBody2", {
                    staticClass: "text-slate-600 truncate",
                    attrs: { text: _vm.placeholder }
                  })
                ],
                1
              )
            : _vm._l(_vm.input, function(i) {
                return _c(
                  "div",
                  { key: i, staticClass: "flex" },
                  [
                    _vm.getAttr(i, "chip")
                      ? _c("BlChip", {
                          staticClass: "truncate",
                          attrs: { chip: i, dense: "" }
                        })
                      : _vm.getAttr(i, "color")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "h-7 max-w-32 px-2 flex items-center rounded truncate",
                            style: {
                              backgroundColor:
                                _vm.getAttr(i, "backgroundColor") || "unset"
                            }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              style: {
                                color: _vm.getAttr(i, "color") || "unset"
                              },
                              attrs: { text: _vm.getAttr(i, "label") }
                            })
                          ],
                          1
                        )
                      : _c("BlTextBody2", {
                          staticClass:
                            "text-slate-800 py-1 px-2 bg-slate-200 truncate max-w-32",
                          attrs: { text: _vm.getAttr(i, "label") || i }
                        })
                  ],
                  1
                )
              }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "absolute right-px w-9 h-10 py-2 px-2 transition-all duration-300",
              class: [_vm.disabled ? "bg-grey-100" : "bg-pure-white"]
            },
            [
              _c("BlIcon", {
                staticClass: "w-5 h-5 transition-all duration-300",
                class: [
                  _vm.disabled ? "pointer-events-none cursor-not-allowed" : ""
                ],
                style: { rotate: _vm.focus ? "180deg" : "" },
                attrs: { icon: "chevron-down" }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      !_vm.disabled && _vm.focus
        ? _c(
            "div",
            {
              staticClass:
                "absolute z-50 max-h-72 w-66 mt-2 py-2 px-2 flex flex-col gap-2 flex-shrink-0 bg-pure-white rounded border border-grey-200 shadow-md",
              attrs: { "data-id": _vm.id }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "px-4 py-2 flex items-center justify-between border-b border-slate-400",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _c("BlTextSubtitle2", {
                    attrs: { "data-id": _vm.id, text: _vm.label }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cursor-pointer",
                      attrs: { "data-id": _vm.id },
                      on: { click: _vm.onClearAll }
                    },
                    [
                      _c("BlTextSubtitle2", {
                        staticClass:
                          "text-light-purple hover:text-dark-purple-200",
                        attrs: { "data-id": _vm.id, text: "Clear all" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.search
                ? _c(
                    "div",
                    {
                      staticClass: "relative flex items-center",
                      attrs: { "data-id": _vm.id }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.query,
                            expression: "query"
                          }
                        ],
                        staticClass:
                          "py-2 px-4 w-full border border-grey-200 rounded focus:border-light-purple outline-none text-sm flex-shrink-0",
                        attrs: {
                          "data-id": _vm.id,
                          id: "search_field_" + _vm.id,
                          type: "text",
                          placeholder: _vm.searchPlaceholder
                        },
                        domProps: { value: _vm.query },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.query = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlIcon", {
                        staticClass: "absolute right-2 w-4",
                        attrs: { "data-id": _vm.id, icon: "search" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filteredOptions.length === 0
                ? _c(
                    "div",
                    {
                      staticClass: "py-2 px-4 flex items-center justify-center",
                      attrs: { "data-id": _vm.id }
                    },
                    [
                      _vm.fetchLoading
                        ? _c("div", {
                            staticClass: "blum-loader-sm",
                            attrs: { "data-id": _vm.id }
                          })
                        : _c("BlTextBody2", {
                            attrs: {
                              "data-id": _vm.id,
                              text: "Option not found"
                            }
                          })
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "px-2 flex flex-col overflow-y-auto",
                      attrs: { "data-id": _vm.id }
                    },
                    [
                      _vm._l(_vm.filteredOptions, function(opt) {
                        return _c(
                          "div",
                          {
                            key: opt.value,
                            staticClass:
                              "py-2 flex items-center gap-2 flex-shrink-0 truncate cursor-pointer",
                            attrs: { "data-id": _vm.id, title: opt.label },
                            on: {
                              click: function($event) {
                                return _vm.onSelect(opt)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "bl-filter-checkbox",
                                class: {
                                  "checkbox-checked": _vm.isChecked(opt.value)
                                },
                                attrs: { "data-id": _vm.id }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "bl-checkbox-icon",
                                  class: [
                                    _vm.isChecked(opt.value)
                                      ? "opacity-100"
                                      : "opacity-0"
                                  ],
                                  attrs: {
                                    "data-id": _vm.id,
                                    icon: "check",
                                    color: "secondary"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            opt.chip
                              ? _c("BlChip", {
                                  attrs: {
                                    "data-id": _vm.id,
                                    id: _vm.id,
                                    chip: opt.value,
                                    dense: ""
                                  }
                                })
                              : opt.color
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "max-w-full h-7 px-2 flex items-center rounded truncate",
                                    style: {
                                      backgroundColor:
                                        opt.backgroundColor || "unset"
                                    },
                                    attrs: { "data-id": _vm.id }
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "truncate",
                                      style: { color: opt.color || "unset" },
                                      attrs: {
                                        "data-id": _vm.id,
                                        text: opt.label
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c("BlTextBody2", {
                                  staticClass: "truncate",
                                  attrs: { "data-id": _vm.id, text: opt.label }
                                })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.isShowMoreOption
                        ? _c("BlInputButton", {
                            staticClass: "mt-2 hover:bg-hover-state",
                            attrs: {
                              dataId: _vm.id,
                              type: "plain",
                              label: "See more ...",
                              dense: "",
                              loading: _vm.fetchLoading
                            },
                            on: { clicked: _vm.onMoreOption }
                          })
                        : _vm._e()
                    ],
                    2
                  )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-698bff0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698bff0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlSingleFilter.vue
// module id = null
// module chunks = 